import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Navbar from '../navbar/Navbar';
import About from '../about/About';
import Services from '../services/Services';
import Gallery from '../gallery/Gallery';
import Contact from '../contact/Contact';
import Remarks from '../remarks/Remarks';
import Footer from '../footer/Footer';
import SocialLinks from '../socialids/socialLinks';
import Courses from '../courses/Courses';

import { sliderSettings, galleryImages, services, remarks } from './salonData';

// Main SalonApp component
function SalonApp() {
  return (
    <div className="font-sans text-gray-800">
      {/* Fixed Navbar */}
      <Navbar />

     
      {/* Slider Section */}
    <section 
            className="max-w-8xl max-h-5xl mx-auto  rounded-xl shadow-xl bg-pink-100 mt-6 mb-8" 
            id="slider-container"
        >
            <div className="w-full overflow-hidden relative" id="slider">
                
                {/* BIG WATERMARK TEXT */}
                <span className="absolute inset-0 flex items-center justify-center pointer-events-none z-10 opacity-40">
                    <span className="text-6xl sm:text-8xl lg:text-9xl font-extrabold text-purple-900 select-none">
                        TREND'Z
                    </span>
                </span>
                
                <Slider {...sliderSettings}>
                    {/* Displaying all images now that navigation is enabled */}
                    {galleryImages.map((img, idx) => (
                        <div key={idx} className="h-64 md:h-96 lg:h-[400px]">
                            {/* Inner element must be relative to ensure the watermark is behind it */}
                            <img 
                                src={img.src} 
                                alt={`Slide ${idx + 1}`} 
                                className="w-full h-full object-cover rounded-lg relative z-20" 
                            />
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
       {/* About Section */}
       <About />
      {/* Place the social links component here (e.g., right after the Navbar) */}
      <SocialLinks position="sidebar" />


      {/* Services Section */}
      <Services services={services} />
      <Courses />

      {/* Gallery Section */}
      <Gallery images={galleryImages} />

      {/* Contact Section */}
      <Contact />

      {/* Customer Remarks Section */}
      <Remarks remarks={remarks} />

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default SalonApp;